import { render, staticRenderFns } from "./ForgetPasswordView.vue?vue&type=template&id=669aed00&scoped=true&"
import script from "./ForgetPasswordView.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordView.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/all.css?vue&type=style&index=0&id=669aed00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669aed00",
  null
  
)

export default component.exports